// OR5
export const OR5_SILVER_KEY = 'OuraRing5Silver';
export const OR5_BLACK_KEY = 'OuraRing5Black';
export const OR5_STEALTH_KEY = 'OuraRing5Stealth';
export const OR5_BRUSHED_SILVER_KEY = 'OuraRing5BrushedSilver';
export const OR5_GOLD_KEY = 'OuraRing5Gold';
export const OR5_DEEP_ROSE_KEY = 'OuraRing5DeepRose';

export const OR5_KEYS = [
  OR5_SILVER_KEY,
  OR5_BLACK_KEY,
  OR5_STEALTH_KEY,
  OR5_BRUSHED_SILVER_KEY,
  OR5_GOLD_KEY,
  OR5_DEEP_ROSE_KEY,
];

// OR4 Titanium
export const OR4_SILVER_KEY = 'OuraRing4Silver';
export const OR4_BLACK_KEY = 'OuraRing4Black';
export const OR4_STEALTH_KEY = 'OuraRing4Stealth';
export const OR4_BRUSHED_SILVER_KEY = 'OuraRing4BrushedSilver';
export const OR4_GOLD_KEY = 'OuraRing4Gold';
export const OR4_ROSE_GOLD_KEY = 'OuraRing4RoseGold';

export const OR4_TITANIUM_KEYS = [
  OR4_SILVER_KEY,
  OR4_BLACK_KEY,
  OR4_STEALTH_KEY,
  OR4_BRUSHED_SILVER_KEY,
  OR4_GOLD_KEY,
  OR4_ROSE_GOLD_KEY,
];

// OR4 Ceramic
export const OR4_MIDNIGHT_KEY = 'OuraRing4CerMidnight';
export const OR4_CLOUD_KEY = 'OuraRing4CerCloud';
export const OR4_TIDE_KEY = 'OuraRing4CerTide';
export const OR4_PETAL_KEY = 'OuraRing4CerPetal';

export const OR4_CERAMIC_KEYS = [
  OR4_MIDNIGHT_KEY,
  OR4_CLOUD_KEY,
  OR4_TIDE_KEY,
  OR4_PETAL_KEY,
];

// Chargers
export const CHARGER_OR5_KEY = 'OuraRing5Charger';
export const CHARGER_CASE_OR5_KEY = 'OuraRing5ChargerCase';
export const CHARGER_CASE_OR4_KEY = 'OuraRing4ChargerCase';
export const CHARGER_OR4_KEY = 'OuraRing4Charger';
export const CHARGER_SET_GEN3_KEY = 'ChargerSet3x';

export const CHARGER_KEYS = [
  CHARGER_OR5_KEY,
  CHARGER_CASE_OR5_KEY,
  CHARGER_CASE_OR4_KEY,
  CHARGER_OR4_KEY,
  CHARGER_SET_GEN3_KEY,
];

// Accessories
export const DEXCOM_STELO_KEY = 'SteloDexcomCGM';

// Warranties
export const EXTENDED_WARRANTY_2YR_KEY = 'ExtendedWarranty2Year';
export const EXTENDED_WARRANTY_3YR_KEY = 'ExtendedWarranty3Year';

export const EXTENDED_WARRANTY_KEYS = [
  EXTENDED_WARRANTY_2YR_KEY,
  EXTENDED_WARRANTY_3YR_KEY,
];

// Membership
export const SUBSCRIPTION_KEY = 'Subscription';
export const MEMBERSHIP_1YR_KEY = 'OneYearMembership';

export const MEMBERSHIP_KEYS = [SUBSCRIPTION_KEY, MEMBERSHIP_1YR_KEY];
